export function replaceCitationMarkersWithLinks(text: string) {
  if (!text) return '';
  // Replace occurrences like "Citation340" with a markdown link whose href is a stable anchor.
  return text.replace(/Citation(?:Match)?(\d+)/g, (_match, num) => `[${num}](#citation-${num})`);
}
